import React from 'react';

export interface MessageDraftDetail {
  content: string;
  date: Date;
}
export interface MessageDraft {
  [conversationId: string]: MessageDraftDetail | undefined;
}
export enum ListInteractionView {
  List = 'list',
  Grid = 'grid',
}
class BrowserStorage {
  // Desktop Notifications
  public desktopNotificationsEnabled = false;
  public desktopNotificationsToastDismissed = false;
  public messagesContent: MessageDraft = {};
  public addOnsBannerDismissed = false;
  public interactionsView: ListInteractionView = ListInteractionView.List;
  public wizardStore: { base?: string; lastPath?: string; formData?: Record<string, any> } = {};

  private applyProperties(props: BrowserStorage): void {
    Object.keys(props).map((key) => ((this as any)[key] = (props as any)[key]));
  }

  constructor() {
    this.load();
  }

  private isSSR(): boolean {
    return typeof window === 'undefined';
  }

  public load(): BrowserStorage {
    if (this.isSSR()) return this;

    try {
      this.applyProperties({
        ...JSON.parse(localStorage.getItem('eWebinar') ?? '{}'),
      });
    } catch (e) {
      console.error('Error loading localStorage: ', e);
    }

    return this;
  }

  public save(): void {
    if (this.isSSR()) return;

    try {
      localStorage.setItem('eWebinar', JSON.stringify(this));
    } catch (e) {
      console.error('Error saving localStorage: ', e);
    }
  }
}

const useBrowserStorage = (): BrowserStorage => {
  const [browserStorage] = React.useState(() => new BrowserStorage());
  return browserStorage;
};

export default useBrowserStorage;
